<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yonghu/bscCustomer',title:'用户管理'},{title:'潜在客户'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="区域">
								<brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"
										  style="width:100%;"/>
							</el-form-item>
							<el-form-item label="渠道">
								<brselect category="sales_region" :v="q.channelCode" v-model="q.channelCode"
										  :clearable="true"
										  style="width:100%;"/>
							</el-form-item>
							<el-form-item label="用户名称">
								<el-input v-model="q.userNameLike"></el-input>
							</el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
								<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
										   @click="adduser">新增用户
								</el-button>
							</el-form-item>
						</div>
					</el-form>
				</div>

            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              stripe
							  :border="true"
                              style="width: 100%"
							  max-height="450">
                        <el-table-column
                                type="selection"
								width="45"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="userName"
                                label="用户名称"
								min-width="200"
                                :show-overflow-tooltip="true"
                               >
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.userName}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="areaCode"
                                :show-overflow-tooltip="true"
                                label="区域">
                            <template slot-scope="scope">
                                {{scope.row.areaCode | dictname('YLRegion')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="channelCode"
                                :show-overflow-tooltip="true"
                                label="渠道">
                            <template slot-scope="scope">
                                {{scope.row.channelCode | dictname('sales_region')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="department"
                                :show-overflow-tooltip="true"
                                label="部门/科室">
                        </el-table-column>
                        <el-table-column
                                prop="contactuserName"
                                :show-overflow-tooltip="true"
                                label="联系人">
                        </el-table-column>
                        <el-table-column
                                prop="telephone"
                                :show-overflow-tooltip="true"
                                label="联系方式">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.telephone}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                :show-overflow-tooltip="true"
                                label="创建人">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
								width="160"
                                label="创建时间">
                        </el-table-column>
                        <el-table-column
                                label="操作"
                        width="120">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="handleEdit(scope.row)">
                                    修改
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <!-- <el-button class="h-btn h-formBtn" @click="uploaddownexcelflagbtn">导入Excel</el-button> -->
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="customerImportExcel"
                                    :startrow="3" @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增用户</h1>
                            <p>New Customer</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改用户信息</h1>
                            <p>update Customer</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                        <el-form-item label="用户名称" class="h-elformWrap-2" prop="userName">
                            <el-input v-model.trim="f.userName" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                            <brselect category="YLRegion" :v="f.areaCode" v-model="f.areaCode" :clearable="true"
                            />
                        </el-form-item>
                        <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode">
                            <brselect category="sales_region" :v="f.channelCode" v-model="f.channelCode"
                                      :clearable="true"
                            />
                        </el-form-item>
                        <el-form-item label="部门/科室" class="h-elformWrap-2" prop="department">
                            <el-input v-model.trim="f.department" placeholder="请输入"/>
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                            <el-input v-model.trim="f.contactuserName" placeholder="请输入"/>
                        </el-form-item>
                        <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                            <el-input v-model.trim="f.telephone" placeholder="请输入" maxlength="20"
                                      oninput="value=value.replace(/[^\d]/g,'')"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer" style="padding-top: 20px;">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                //分页/检索
                q: {
                    areaCode: '',
                    channelCode: '',
                    userNameLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f: {
                    areaCode: null,
                    channelCode: null,
                    userName: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                },
                //表格
                multipleSelection: [],
                //table列表
                tableData: [],
                //弹窗
                dialogFormVisible: false,
                rules:
                    {
                        userCode: [{required: true, message: '请输入用户编码', trigger: 'blur'}],
                        userName: [{required: true, message: '请输入用户名称', trigger: 'blur'}],
                        areaCode: [{required: true, message: '请选择区域', trigger: 'blur'}],
                        channelCode: [{required: true, message: '请选择渠道', trigger: 'blur'}],
                        department: [{required: true, message: '请输入部门/科室', trigger: 'blur'}],
                        contactuserName: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                        telephone: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
                    }
            }
        },
        created() {
            this.query();
        },
        methods: {
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.areaCode = '';
                this.q.channelCode = '';
                this.q.userNameLike = '';
            },
            query() {
                ss.customer.selecePage(this.q).then(rd => {
                    //console.log(rd,"AA");
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.f.id = null,
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.saveorupdate = 1;
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                var subflag = false;
                if (this.saveorupdate == 1) {
                    this.$refs['f'].validate((valid) => {
                        if (valid) {
                            subflag = true;
                        } else {
                            this.$msg.msge("请完善信息后再提交！");
                            return false;
                        }
                    });
                } else if (this.saveorupdate == 2) {
                    subflag = true;
                }
                if (subflag == true) {
                    ss.customer.insert(this.f).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                        this.dialogFormVisible = false;
                    })
                }
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.customer.deleteById(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //编辑
            handleEdit(value) {
                this.saveorupdate = 2;
                ss.customer.selectById(value.id).then(rd => {
                    this.dialogFormVisible = true;
                    this.f = rd;
                })
            },
            //批量导出
          exportExcel() {
            updownfile.down("/api/swyl/v1/yonghu/bscCustomer/downloadExcelBscCustomer",this.q,"post",'data');
          },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
</style>
